import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthContext';

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { status, currentUser } = useAuth();
  const location = useLocation();

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }

  // Force password change before access to any other protected route.
  if (
    currentUser?.allow_password_change === true &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
